import { ExplorerEnvironment } from "../data/Cache";
import { NBA_TEAMS, GLEAGUE_TEAMS } from "../data/teams";

export type Team = {
  abbrev: string;
  city: string;
  name: string;
  nbaId: number;
  conference?: string;
  division?: string;
};

export function getTeamLogoUrl(team: Team): string {
  return getTeamLogoUrlForEnvironment(team.nbaId, ExplorerEnvironment.NBA);
}

export function getTeamLogoUrlForEnvironment(
  nbaId: number,
  environment: ExplorerEnvironment
): string {
  if (!nbaId) {
    return "/images/nba-logo.png";
  }
  if (environment === ExplorerEnvironment.DRAFT) {
    return `https://ak-static.cms.nba.com/wp-content/uploads/logos/nbagleague/${nbaId}/primary/D/logo.svg`;
  }
  return `https://cdn.nba.com/logos/nba/${nbaId}/primary/L/logo.svg`;
}

const TEAMS_BY_ENVIRONMENT: Record<ExplorerEnvironment, Team[]> = {
  [ExplorerEnvironment.NBA]: NBA_TEAMS,
  [ExplorerEnvironment.DRAFT]: GLEAGUE_TEAMS,
};

export function getTeamsForEnvironment(
  environment: ExplorerEnvironment
): Team[] {
  return TEAMS_BY_ENVIRONMENT[environment];
}

export function getTeamFromString(
  abbrev: string,
  environment: ExplorerEnvironment = ExplorerEnvironment.NBA
): Team {
  const teams = getTeamsForEnvironment(environment);
  const team = teams.find(
    (t) => t.abbrev.toLowerCase() === abbrev.toLowerCase()
  );
  if (!team) {
    return {
      abbrev: "UNK",
      city: "Unknown",
      name: "Team",
      nbaId: 0,
    };
  }
  return team;
}
